/* eslint-disable no-unused-vars */

import _ from "lodash";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Button, Card, Col, Form, Modal, Row, Table} from "react-bootstrap";
import {BiEdit, BiPlus, BiTrash} from "react-icons/bi";
import {Get, Post} from "../../lib/Request";
import {ConsoleLog} from "../../lib/ConsoleHelper";
import {ALERT_VARIANT, AuthColumnPageEnum} from "../../const/dataEnum";
import {API_ACTION, API_AUTH_ROLE, API_AUTH_ROLE_ACTIONS_ROLE, API_AUTHACTION} from "../../const/Api";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import LoadingComponent from "../../components/LoadingComponent";

const defaultRole = {
  id: "",
  role: "",
  roleOrder: "0",
};

const defaultAction = {
  id: 0,
  action: "",
};

export default function UserAuthentication() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [authRoles, setAuthRole] = useState([]);
  const [authActions, setAuthAction] = useState([]);
  const [authRoleActions, setAuthRoleAction] = useState([]);

  const [loadingRole, setLoadingRole] = useState(true);
  const [loadingAction, setLoadingAction] = useState(true);
  const [loadingRoleAction, setLoadingRoleAction] = useState(false);
  const [loadingModify, setLoadingModify] = useState(false);

  const [entity, setEntity] = useState(AuthColumnPageEnum.AUTH_ROLE_COL);
  const [mode, setMode] = useState("Register");
  const [selectedObject, setSelectedObject] = useState(defaultRole);
  const [selectedRole, setSelectedRole] = useState("manager");

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getRole();
      getAction();
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  async function getRole() {
    setLoadingRole(true);
    let result = await Get(API_AUTH_ROLE);

    setLoadingRole(false);
    setAuthRole(result.data);
  }

  async function getAction() {
    setLoadingAction(true);
    let result = await Get(API_AUTHACTION);
    setAuthAction(result.data);
    setLoadingAction(false);
  }

  async function getRoleAction(role) {
    setSelectedRole(role);
    setLoadingRoleAction(true);
    setShowRegister(true);
    let result = await Get(API_AUTH_ROLE_ACTIONS_ROLE + `/${role}`);
    ConsoleLog("result :", result);
    ConsoleLog("authActions :", authActions);

    let temp = authActions.map((element) => {
      let data = _.cloneDeep(element);
      data.access = false;
      result?.data?.forEach((el) => {
        if (data.id === el.authActionID) {
          data.access = true;
        }
      });
      return _.cloneDeep(data);
    });
    setAuthRoleAction(temp);
    setLoadingRoleAction(false);
  }

  function validateForm() {
    let value = entity === 'AuthRole' ? selectedObject.role : selectedObject.action
    return true;
  }

  function setNameValue(value) {
    if (entity === AuthColumnPageEnum.AUTH_ROLE_COL) {
      selectedObject.role = value;
    } else {
      selectedObject.action = value;
    }
    setSelectedObject(_.cloneDeep(selectedObject));
  }

  function modifyData(type, data) {
    setEntity(type);
    setSelectedObject(_.cloneDeep(data));
    handleShow();
  }

  async function deleteData() {
    let url = "";
    if (entity === AuthColumnPageEnum.AUTH_ROLE_COL) {
      url = API_AUTH_ROLE + API_ACTION.DELETE;
    } else {
      url = API_AUTHACTION + API_ACTION.DELETE;
    }
    let result = await Post(url, selectedObject);
    if (result.responseCode === 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: "Item Deleted"}));
      setShowDelete(false);
      getRole();
      getAction();
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: "Error when deleting item"}));
    }
  }

  async function addOrUpdateData(event) {
    event.preventDefault();
    setLoadingModify(true);
    let param = _.cloneDeep(selectedObject);
    let url = "";
    const action = mode === "Register" ? API_ACTION.CREATE : API_ACTION.UPDATE;
    if (entity === AuthColumnPageEnum.AUTH_ROLE_COL) {
      if (action === API_ACTION.CREATE) {
        param.id = 0;
      }
      param.roleOrder = String(authRoles.length + 1);
      url = API_AUTH_ROLE + action;
    } else {
      url = API_AUTHACTION + action;
    }
    let result = await Post(url, param);

    setLoadingModify(false);
    if (result.responseCode === 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: result.message}));
      if (entity === AuthColumnPageEnum.AUTH_ROLE_COL) {
        setSelectedObject(_.cloneDeep(defaultRole));
        getRole();
      } else {
        setSelectedObject(_.cloneDeep(defaultAction));
        getAction();
      }
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
    }
    setShow(false);
  }

  async function updateRoleAction() {
    setLoadingModify(true);
    let param = [];

    authRoleActions.forEach((element) => {
      if (element.access) {
        param.push({
          id: 0,
          authRoleID: selectedRole,
          authActionID: element.id,
          actionAllowed: 1,
          actionDenied: 1,
        });
      }
    });
    let result = await Post(API_AUTH_ROLE_ACTIONS_ROLE + `/${selectedRole}/register`, param);
    setLoadingModify(false);
    setShowRegister(false);
    dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: "Success"}));
  }

  const onHandleEdit = (type, element) => {
    setMode("Edit");
    modifyData(type, element);
  };

  const onHandleRoleAction = (element) => {
    getRoleAction(element.id);
  };

  const onHandleDelete = (type, element) => {
    setEntity(type);
    setSelectedObject(element);
    setShowDelete(true);
  };

  function display(type, data, loading) {
    return (
      <div>
        <h4>
          <b>{type}</b>
        </h4>
        <Button
          className="mb-4"
          onClick={() => {
            setMode("Register");
            modifyData(type, type === AuthColumnPageEnum.AUTH_ROLE_COL ? defaultRole : defaultAction);
          }}
        >
          Register {type === AuthColumnPageEnum.AUTH_ROLE_COL ? "AuthRole" : "AuthAction"} <BiPlus/>
        </Button>
        <Table>
          <thead>
          <tr>
            <th width="50">No</th>
            <th width="250">{type === AuthColumnPageEnum.AUTH_ROLE_COL ? "AuthRole" : "AuthAction"}</th>
            <th width="100"></th>
          </tr>
          </thead>
          <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan={3}>
                {<LoadingComponent/>}
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td className="text-center" colSpan={3}>
                No Data
              </td>
            </tr>
          ) : (
            data.map((element, index) => {
              return (
                <tr id={index} key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{type === AuthColumnPageEnum.AUTH_ROLE_COL ? element.role : element.action}</td>
                  <td>
                    <div style={{display: "flex", gap: "8px"}}>
                      <Button onClick={() => onHandleEdit(type, element)}>
                        <BiEdit/>
                      </Button>
                      <Button onClick={() => onHandleRoleAction(element)}>
                        <BiPlus/>
                      </Button>
                      {/* hide the Button Delete for all cloums */}
                      {(type === AuthColumnPageEnum.AUTH_ROLE_COL) && (
                        <>
                          <Button variant="danger" onClick={() => onHandleDelete(type, element)}>
                            <BiTrash/>
                          </Button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          )}
          </tbody>
        </Table>
      </div>
    );
  }

  return (
    <div className="container">
      <Row>
        <Col>{display(AuthColumnPageEnum.AUTH_ROLE_COL, authRoles, loadingRole)}</Col>
        <Col>{display(AuthColumnPageEnum.AUTH_ACTION_COL, authActions, loadingAction)}</Col>
      </Row>

      <Modal
        show={showRegister}
        onHide={() => {
          setShowRegister(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Register Role Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {authRoleActions.map((element, index) => {
            return (
              <Card key={"Role" + index}>
                <Card.Body>
                  <Row>
                    <Col>{element.action}</Col>
                    <Col style={{textAlign: "right"}}>
                      <Form.Check
                        inline
                        label=""
                        name="group1"
                        type="checkbox"
                        checked={element.access}
                        onChange={(e) => {
                          let x = _.cloneDeep(authRoleActions);
                          x[index].access = e.target.checked;
                          setAuthRoleAction(x);
                        }}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            );
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="md"
            type="button"
            style={{width: "150px"}}
            onClick={() => {
              updateRoleAction();
            }}
            disabled={loadingModify || authRoleActions.filter((menu) => menu.access === true).length === 0}
          >
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: "0px"}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              "Save"
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setShowRegister(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to delete this data?</Modal.Body>
        <Modal.Footer>
          <Button
            size="md"
            type="button"
            variant="danger"
            style={{width: "150px"}}
            onClick={() => {
              deleteData();
            }}
            disabled={loadingModify}
          >
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: "0px"}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              "Delete"
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setShowDelete(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={addOrUpdateData}>
          <Modal.Header>
            <Modal.Title>
              {mode} {entity}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group size="lg" controlId="username" className="mb-2">
              <Form.Label>{entity}</Form.Label>
              <Form.Control
                autoFocus
                placeholder={entity + " Name"}
                type="text"
                value={entity === AuthColumnPageEnum.AUTH_ROLE_COL ? selectedObject.role : selectedObject.action}
                onChange={(e) => setNameValue(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button size="md" type="submit" style={{width: "150px"}} disabled={!validateForm() || loadingModify}>
              {loadingModify ? (
                <div>
                  <span
                    style={{marginLeft: "0px"}}
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              ) : (
                "Save Changes"
              )}
            </Button>
            <Button variant="secondary" onClick={handleClose} disabled={loadingModify}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
